export default "<p>\n    <b>Translate generated texts.</b>\n</p>"